import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, IPromise} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {Debugger} from "debug";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {gettextCatalog} from "angular-gettext";

const css = require('./visSkjermingDialog.scss');
const debug: Debugger = require('debug')('VisSkjermingDialog');

export class VisSkjermingDialog implements IController {

    static visSkjermingDialog(avhengigheter: Avhengigheter, $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon({avhengigheter: avhengigheter}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./visSkjermingDialog.html'),
            controller: VisSkjermingDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            GruppeRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            regNavn.md.$mdDialog,
            VisSkjermingDialog
        ]
    }

    constructor(private kontekst: Kontekst, private gruppeRessurs: GruppeRessurs, private gettextCatalog: gettextCatalog, private $mdDialog: angular.material.IDialogService) {
    }

    avhengigheter: Avhengigheter; //settes via locals

    modus: 'vis'|'rediger'|'skjermet' = 'vis';
    skjerming: l.SkjermingDetaljerModell;
    skjemamodell: Skjemamodell;
    melding: string;
    tittel: string;
    feilMeldinger: string[]; // feilmeldinger hvis det det kommer valideringsfeil fra server

    rediger(){
        this.modus = 'rediger';
        this.initSkjema();
    }

    lagre(){
        this.avhengigheter.oppdaterSkjerming(this.skjemamodell.somSpesifikasjon())
            .then( validering =>{
                if (validering.valideringsresultat.harFeil) {
                    this.feilMeldinger = [];
                    validering.valideringsresultat.feil.forEach(f => {
                        switch (f.feilkode) {
                            case l.SkjermingValideringsfeil.medlem_skal_signere_protokoll:
                                this.feilMeldinger.push(this.gettextCatalog.getString("{{medlemNavn}} skal signere protokoll, så tilgang kan ikke stenges", {medlemNavn: this.finnMedlemNavn(f.data.medlemId)}));
                                break;
                            case l.SkjermingValideringsfeil.stenge_egen_tilgang:
                                this.feilMeldinger.push(this.gettextCatalog.getString("{{medlemNavn}} kan ikke stenge egen tilgang", {medlemNavn: this.finnMedlemNavn(f.data.medlemId)}));
                                break;
                            case l.SkjermingValideringsfeil.fjerne_egen_skjerming:
                                this.feilMeldinger.push(this.gettextCatalog.getString("{{medlemNavn}} kan ikke gi seg selv tilgang", {medlemNavn: this.finnMedlemNavn(f.data.medlemId)}));
                                break;
                            case l.SkjermingValideringsfeil.medlem_skal_signere_dokument:
                                this.feilMeldinger.push(this.gettextCatalog.getString("{{medlemNavn}} skal signere et dokument, så tilgang kan ikke stenges", {medlemNavn: this.finnMedlemNavn(f.data.medlemId)}));
                                break;
                            case l.SkjermingValideringsfeil.ikke_medlem_i_gruppe: // skal ikke kunne skje i GUI
                            default:
                                this.feilMeldinger.push("En feil har oppstått: kode=" + f.feilkode)
                                break;
                            }
                    });
                    return;
                } 
                this.feilMeldinger = null;
                this.lukk();
            })
    }

    finnMedlemNavn(medlemId: string): string {
        const medlem = this.skjemamodell.tilgjengeligeMedlemmer.filter(m => m.id === medlemId).pop();
        if (medlem) {
            return medlem.navn;
        }
        // finner ikke medlem, skriver ut id så kan vi ihvertfall se hva feilen er.
        return medlemId
    }

    avbrytRediger(){
        this.avbryt();
    }

    lukk(){
        this.$mdDialog.hide();
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit(): void {
        this.tittel = this.dialogTittel();
        if (this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.avhengigheter.gruppeId()))
            this.modus = 'rediger';
        else
            this.modus = 'vis';
        this.initSkjerming()
            .then(() =>{
                if (this.skjerming.harSkjermetForelderForKallendeBruker || this.skjerming.erSkjermetForKallendeBruker || this.skjerming.inneholderBarnSkjermetForKallendeBruker) {
                    this.modus = 'skjermet';
                    this.melding = this.meldingVedSkjermetForKallendeBruker();
                } else if (this.modus == 'rediger') {
                    this.initSkjema();
                    this.melding = this.meldingVedMedlemmerUtenTilgangTilForelder();
                }
            });
    }

    //hjelpemetoder

    private initSkjerming(): IPromise<void> {
        return this.avhengigheter.hentSkjerming()
            .then(skjerming => {
                this.skjerming = skjerming;
            });
    }

    private dialogTittel(){
        switch (this.avhengigheter.entitetType){
            case 'møte': return this.gettextCatalog.getString('Tilgangsbegrensning for møte')
            case 'sak': return this.gettextCatalog.getString('Tilgangsbegrensning for sak')
            case 'saksdokument': return this.gettextCatalog.getString('Tilgangsbegrensning for saksdokument')
            case 'arkivmappe': return this.gettextCatalog.getString('Tilgangsbegrensning for bibliotekmappe')
            case 'arkivdokument': return this.gettextCatalog.getString('Tilgangsbegrensning for bibliotekdokument')
            default: return '';
        }
    }

    private meldingVedSkjermetForKallendeBruker(){
        if(this.skjerming.harSkjermetForelderForKallendeBruker){
            switch (this.avhengigheter.entitetType){
                case 'sak': return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende møte.')
                case 'saksdokument': return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende sak.')
                case 'arkivmappe':
                case 'arkivdokument': return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til overliggende mappe.')
                default: return '';
            }
        }
        if(this.skjerming.erSkjermetForKallendeBruker){
            return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang.')
        }
        if(this.skjerming.inneholderBarnSkjermetForKallendeBruker){
            switch (this.avhengigheter.entitetType){
                case 'møte': return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til saker eller dokumenter tilknyttet dette møtet.')
                case 'sak': return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til dokumenter tilknyttet denne saken.')
                case 'arkivmappe': return this.gettextCatalog.getString('Du kan ikke redigere tilgang da noen andre allerede har fjernet din tilgang til dokumenter eller mapper under denne biblioteksmappen.')
                default: return '';
            }
        }
    }

    private meldingVedMedlemmerUtenTilgangTilForelder(){
        switch (this.avhengigheter.entitetType){
            case 'sak': return this.gettextCatalog.getString('Merk at følgende medlemmer ikke har tilgang til overliggende møte og derfor ikke kan fjernes')
            case 'saksdokument': return this.gettextCatalog.getString('Merk at følgende medlemmer ikke har tilgang til overliggende sak og derfor ikke kan fjernes')
            case 'arkivmappe':
            case 'arkivdokument': return this.gettextCatalog.getString('Merk at følgende medlemmer ikke har tilgang til overliggende mappe og derfor ikke kan fjernes')
            default: return '';
        }
    }

    private initSkjema(){
        const kallendeMedlem = this.kontekst.medlemRepresentasjonTilknyttet(this.avhengigheter.gruppeId());
        this.skjemamodell = new Skjemamodell();
        this.skjemamodell.aarsak = this.skjerming.aarsak;
        this.gruppeRessurs.hent(this.avhengigheter.gruppeId()).$promise
            .then(gruppe => {
                const medlemmer = gruppe.medlemmer;
                //sørger for at kallende bruker ikke kan forby egen tilgang
                this.skjemamodell.tilgjengeligeMedlemmer = medlemmer.filter(medlem => medlem.id !== kallendeMedlem.id);
                this.skjemamodell.medlemmerUtenTilgang = this.skjemamodell.tilgjengeligeMedlemmer
                    .filter(medlem => this.skjerming.medlemmerUtenTilgang.some(skjermet => skjermet.id === medlem.id));
                this.skjemamodell.medlemmerUtenTilgangTilForelder = this.skjemamodell.tilgjengeligeMedlemmer
                    .filter(medlem => this.skjerming.medlemmerIdUtenTilgangTilForelder.some(skjermet => skjermet === medlem.id));
            });
    }

    [s: string]: any;
}

class Skjemamodell {
    medlemmerUtenTilgang:l.GruppeMedlemListeModell[];
    tilgjengeligeMedlemmer: l.GruppeMedlemListeModell[];
    medlemmerUtenTilgangTilForelder: l.GruppeMedlemListeModell[];
    gruppe:l.GruppeModell;
    aarsak = '';

    somSpesifikasjon(): l.OppdaterSkjermingSpesifikasjon {
        return {
            medlemmerUtenTilgang: this.medlemmerUtenTilgang.map(medlem => medlem.id),
            aarsak: this.aarsak
        };
    }
}

export interface Avhengigheter{
    entitetType: 'møte'|'sak'|'saksdokument'|'arkivmappe'|'arkivdokument'
    gruppeId(): string;
    hentSkjerming(): IPromise<l.SkjermingDetaljerModell>;
    oppdaterSkjerming(spesifikasjon: l.OppdaterSkjermingSpesifikasjon): IPromise<l.SkjermingDetaljerMedValideringsresultatModell<l.SkjermingValideringsfeil>>;
}
